import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import 'moment-duration-format';
import { findCurrency } from 'currency-formatter';
import { findNumbers, parsePhoneNumber } from 'libphonenumber-js';
import { getCurrency } from 'locale-currency';
import { find, first, indexOf, isArray, isEqual, isFunction, last, map, reduce as reduce$1, size, sortBy, trimEnd, uniq } from 'lodash';
import moment$1, { duration, isMoment, localeData } from 'moment';
import { extendMoment } from 'moment-range';
import PropTypes from 'prop-types';
import { parse, stringify } from 'qs';
import { T, all, allPass, always, any, anyPass, assoc, clamp, complement, compose, cond, curry, defaultTo, difference, either, equals, filter, find as find$1, findIndex, flatten, fromPairs, gt, gte, has, head, identity, is, isEmpty, isNil, join, keys, last as last$1, length, lensPath, lt, lte, map as map$1, mapObjIndexed, match, maxBy, mergeDeepRight, minBy, not, omit, over, pathOr, pipe, prop, propEq, propOr, propSatisfies, range, reduce, sort, split, startsWith, test, toLower, toPairs, toUpper, values, zipObj } from 'ramda';
import Notifications from 'react-notification-system-redux';
import { bindActionCreators } from 'redux';
import { remove } from 'remove-accents';
export { getCurrency } from 'locale-currency';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}
/**
 * Toggle item in array.
 */


var toggleArrayItem = function toggleArrayItem(arr, item) {
  if (isNil(item)) {
    return arr;
  }

  if (find(arr, function (el) {
    return isEqual(el, item);
  })) {
    return arr.filter(function (el) {
      return !isEqual(el, item);
    });
  }

  return arr.concat(item);
};
/**
 * Toggle item in array with a given comparator.
 */


var toggleArrayItemWith = function toggleArrayItemWith(callback, arr, item) {
  if (isNil(item)) {
    return arr;
  }

  if (find(arr, function (el) {
    return callback(el, item);
  })) {
    return arr.filter(function (el) {
      return !callback(el, item);
    });
  }

  return arr.concat(item);
};
/**
 * Check if item is first element of array.
 */


var isFirst = function isFirst(arr, item) {
  return isEqual(first(arr), item);
};
/**
 * Check if item is last element of array.
 */


var isLast = function isLast(arr, item) {
  return isEqual(last(arr), item);
};
/**
 * Find array's item previous element.
 */


var prev = function prev(arr, item) {
  var index = indexOf(arr, item);
  return index > 0 ? arr[index - 1] : undefined;
};
/**
 * Find array's item next element.
 */


var next = function next(arr, item) {
  var index = indexOf(arr, item);
  return index >= 0 && index < length(arr) - 1 ? arr[index + 1] : undefined;
};
/**
 * Sort items by keys.
 */


var sortItemsByKeys = function sortItemsByKeys(items, keys, key) {
  if (key === void 0) {
    key = 'id';
  }

  if (!size(keys)) {
    return items;
  }

  return sortBy(items, function (item) {
    return indexOf(keys, item[key]);
  });
};
/**
 * Sort items by indexes.
 */


var sortItemsByIndexes = function sortItemsByIndexes(items, indexes) {
  return sortBy(items, function (item) {
    return indexOf(indexes, indexOf(items, item));
  });
};
/**
 * Generate array with a given function.
 */


var generate = function generate(size, fn) {
  return range(0, size).map(fn);
};
/**
 * Find first item that matches a given function.
 *
 * @deprecated use `find` from `ramda`
 */


var findFirst = function findFirst(arr, callback) {
  return find(arr, callback);
};
/**
 * Pad an array to a certain length with another array.
 */


var padRight = function padRight(array, size, fill) {
  return __spreadArrays(array, range(0, size).fill(fill)).slice(0, size);
};
/**
 * Sums an array by a given function.
 */


var sumBy = function sumBy(fn) {
  return reduce(function (sum, el) {
    return sum + fn(el);
  }, 0);
};

var LOCAL_STORAGE_TEST_KEY = '_local_storage_test_key_';
/**
 * Check if localStorage is supported by the current client.
 */

var hasLocalStorage = function hasLocalStorage() {
  try {
    if (!localStorage) {
      return false;
    }

    localStorage.setItem(LOCAL_STORAGE_TEST_KEY, LOCAL_STORAGE_TEST_KEY);
    localStorage.removeItem(LOCAL_STORAGE_TEST_KEY);
    return true;
  } catch (error) {
    return false;
  }
};
/**
 * Converts the hex representing an arbitrary ARGB color into RGBA.
 *
 * @example
 *  const argbRed = "#ffff0000";
 *  argbToHex(argbRed); // #ff0000ff
 */


var argbToRgba = function argbToRgba(color) {
  return "#" + color.slice(3, 9) + color.slice(1, 3);
};

var areArgsValid = function areArgsValid(mainString, targetStrings) {
  if (typeof mainString !== 'string') return false;
  if (!Array.isArray(targetStrings)) return false;
  if (!targetStrings.length) return false;
  if (targetStrings.find(function (s) {
    return typeof s !== 'string';
  })) return false;
  return true;
};

var compareTwoStrings = function compareTwoStrings(first, second) {
  var firstParam = first.replace(/\s+/g, '');
  var secondParam = second.replace(/\s+/g, '');
  if (!firstParam.length && !secondParam.length) return 1; // if both are empty strings

  if (!firstParam.length || !secondParam.length) return 0; // if only one is empty string

  if (firstParam === secondParam) return 1; // identical

  if (firstParam.length === 1 && secondParam.length === 1) return 0; // both are 1-letter strings

  if (firstParam.length < 2 || secondParam.length < 2) return 0; // if either is a 1-letter string

  var firstBigrams = new Map();

  for (var i = 0; i < firstParam.length - 1; i += 1) {
    var bigram = firstParam.substr(i, 2);
    var count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) + 1 : 1;
    firstBigrams.set(bigram, count);
  }

  var intersectionSize = 0;

  for (var i = 0; i < secondParam.length - 1; i += 1) {
    var bigram = secondParam.substr(i, 2);
    var count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) : 0;

    if (count > 0) {
      firstBigrams.set(bigram, count - 1);
      intersectionSize += 1;
    }
  }

  return 2.0 * intersectionSize / (firstParam.length + secondParam.length - 2);
};

var findBestMatch = function findBestMatch(mainString, targetStrings) {
  if (!areArgsValid(mainString, targetStrings)) {
    throw new Error('Bad arguments: First argument should be a string, second should be an array of strings');
  }

  var ratings = [];
  var bestMatchIndex = 0;

  for (var i = 0; i < targetStrings.length; i += 1) {
    var currentTargetString = targetStrings[i];
    var currentRating = compareTwoStrings(mainString, currentTargetString);
    ratings.push({
      target: currentTargetString,
      rating: currentRating
    });

    if (currentRating > ratings[bestMatchIndex].rating) {
      bestMatchIndex = i;
    }
  }

  var bestMatch = ratings[bestMatchIndex];
  return {
    ratings: ratings,
    bestMatch: bestMatch,
    bestMatchIndex: bestMatchIndex
  };
};

var filterByTruthy = filter(Boolean);
var isArrayEmpty = pipe(filterByTruthy, isEmpty);
/**
 * Checks if children are empty.
 */

var isChildrenEmpty = function isChildrenEmpty(children) {
  if (Array.isArray(children)) {
    return isArrayEmpty(children);
  }

  return not(children);
};
/**
 * Checks if component has no children prop.
 */


var hasNoChildrenProp = pipe(prop('children'), isChildrenEmpty);
/**
 * Current moment.
 */

var now = function now() {
  return moment$1();
};
/**
 * Checks if two dates are the same.
 *
 * It is an alias for moment's isSame: https://momentjs.com/docs/#/query/is-same/
 */


var isSameDate = function isSameDate(d1, d2, unit) {
  return moment$1(d1).isSame(d2, unit);
};
/**
 * Today at midnight.
 */


var today = function today() {
  return now().startOf('day');
};
/**
 * Add a given number of days to today.
 */


var futureDay = function futureDay(days) {
  return now().add(days, 'days');
};
/**
 * Subtract a given number of days from today.
 */


var pastDay = function pastDay(days) {
  return now().subtract(days, 'days');
};
/**
 * Formats a moment instance date with localization (year, month and day).
 */


var toLocalizedFormat = function toLocalizedFormat(date) {
  return date.format('L');
};
/**
 * Convert weekday to ISO weekday.
 */


var isoWeekday = function isoWeekday(weekday) {
  return weekday === 0 ? 7 : weekday;
};
/**
 * Convert ISO weekday to zero-based weekday.
 */


var weekdayFromISO = function weekdayFromISO(weekday) {
  return weekday === 7 ? 0 : weekday;
};
/**
 * Get the ISO weekday from a date.
 */


var dateToISOWeekday = function dateToISOWeekday(date) {
  return moment$1(date).isoWeekday();
};
/**
 * Converts month to ISO.
 */


var isoMonth = function isoMonth(month) {
  return month + 1;
};
/**
 * Converts ISO month to zero-based month.
 */


var monthFromISO = function monthFromISO(month) {
  return month - 1;
};
/**
 * Normalizes a Java date time period.
 */


var normalizePeriod = function normalizePeriod(period) {
  return period && period.map(function (unit, index) {
    if (index === 1) {
      return monthFromISO(unit);
    }

    if (index === 6) {
      return unit / 10e6;
    }

    return unit;
  });
};
/**
 * Builds a moment.
 */


var buildMoment = function buildMoment(value, utc) {
  if (utc === void 0) {
    utc = false;
  }

  var normalizedValue = isArray(value) ? normalizePeriod(value) : value;
  return utc ? moment$1.utc(normalizedValue) : moment$1(normalizedValue);
};
/**
 * Builds a moment.
 * @deprecated Use `buildMoment`
 */


var toMoment = buildMoment;
/**
 * Builds a moment from pattern.
 */

var buildMomentWithPattern = function buildMomentWithPattern(dateString, pattern) {
  return moment$1(dateString, pattern);
};
/**
 * Builds a moment with patter.
 * @deprecated Use `buildMomentWithPattern`
 */


var toMomentWithPattern = buildMomentWithPattern;
/**
 * Builds a date.
 */

var buildDate = function buildDate(value, utc) {
  if (utc === void 0) {
    utc = false;
  }

  return buildMoment(value, utc).toDate();
};
/**
 * Builds a date.
 * @deprecated Use `buildDate`
 */


var toDate = buildDate;
/**
 * Builds an ISO year month string.
 */

var buildISOYearMonth = function buildISOYearMonth(date, utc) {
  if (utc === void 0) {
    utc = false;
  }

  return buildMoment(date, utc).format('YYYY-MM');
};
/**
 * Builds an ISO year month string.
 * @deprecated Use `buildISOYearMonth`
 */


var toISOYearMonth = buildISOYearMonth;
/**
 * Builds an ISO date.
 */

var buildISODate = function buildISODate(date, utc) {
  if (utc === void 0) {
    utc = false;
  }

  return buildMoment(date, utc).format('YYYY-MM-DD');
};
/**
 * Builds an ISO date.
 * @deprecated Use `buildISODate`
 */


var toISODate = buildISODate;
/**
 * Converts moment to Java date period.
 */

var momentToDatePeriod = function momentToDatePeriod(value) {
  return [value.year(), isoMonth(value.month()), value.date()];
};
/**
 * Gets days in range.
 */


var getDaysInRange = function getDaysInRange(from, to) {
  if (!isMoment(from) && !isMoment(to)) {
    return null;
  }

  if (!isMoment(from)) {
    return -1;
  }

  if (!isMoment(to)) {
    return now().endOf('day').diff(from, 'days') + 1;
  }

  return to.endOf('day').diff(from, 'days') + 1;
};
/**
 * Check if a given date is today.
 */


var isToday = function isToday(date) {
  return buildMoment(date).isSame(now(), 'days');
};
/**
 * Checks if date is in the interval of one year.
 */


var isPeriodBetweenOneYear = function isPeriodBetweenOneYear(period) {
  return period.isSameOrBefore(now().startOf('day'), 'month') && period.isSameOrAfter(now().subtract(0.9, 'years'), 'month');
};
/**
 * Gets the last day of month of a given date.
 */


var lastDayOfMonth = function lastDayOfMonth(date) {
  return new Date(date.year(), date.month() + 1, 0, 23, 59, 59);
};
/**
 * Checks if date is selectable.
 */


var isSelectableDate = function isSelectableDate(isEndDate, from, to) {
  return function (date) {
    if (isEndDate && isMoment(from) && date.isBefore(from)) {
      return false;
    }

    if (!isEndDate && isMoment(to) && date.isAfter(to)) {
      return false;
    }

    return true;
  };
};
/**
 * Checks if date is past and selectable.
 */


var isSelectablePastDate = function isSelectablePastDate(isEndDate, from, to) {
  return function (date) {
    if (!isSelectableDate(isEndDate, from, to)(date)) {
      return false;
    }

    if (date.isSameOrAfter(now(), 'days')) {
      return false;
    }

    return true;
  };
};
/**
 * Checks if date is past or current and selectable.
 */


var isSelectablePastOrCurrentDate = function isSelectablePastOrCurrentDate(isEndDate, from, to) {
  return function (date) {
    if (!isSelectableDate(isEndDate, from, to)(date)) {
      return false;
    }

    if (date.isAfter(now(), 'days')) {
      return false;
    }

    return true;
  };
};
/**
 * Checks if date is today or yesterday and selectable.
 */


var isSelectableTodayAndYesterdayDate = function isSelectableTodayAndYesterdayDate(from) {
  return function (date) {
    if (isMoment(from) && date.isBefore(from) && date !== from) {
      return false;
    }

    if (date.isAfter(now(), 'days')) {
      return false;
    }

    return true;
  };
};
/**
 * Checks if date is future and selectable.
 */


var isSelectableFutureDate = function isSelectableFutureDate(isEndDate, from, to) {
  return function (date) {
    if (!isSelectableDate(isEndDate, from, to)(date)) {
      return false;
    }

    if (date.isBefore(now(), 'days')) {
      return false;
    }

    return true;
  };
};
/**
 * Checks if date is selectable within range.
 */


var isSelectableDateRange = function isSelectableDateRange(from, to) {
  return function (date) {
    if (!isSelectableDate(true, from, to)(date)) {
      return false;
    }

    if (!isSelectableDate(false, from, to)(date)) {
      return false;
    }

    return true;
  };
};
/**
 * Checks if the target date is between the start of the past year, considering the reference date, and the reference date itself.
 */


var isBetweenStartOfPastYear = function isBetweenStartOfPastYear(targetDate, referenceDate) {
  if (referenceDate === void 0) {
    referenceDate = now();
  }

  var targetMomentDate = buildMoment(targetDate);
  var referenceMomentDate = buildMoment(referenceDate);
  var pastYear = buildMoment(referenceDate).subtract(1, 'year').startOf('year');
  return targetMomentDate.isSameOrAfter(pastYear) && targetMomentDate.isSameOrBefore(referenceMomentDate);
};

var MOBILE_BREAKPOINT = 768;
/**
 * Checks if window is in mobile viewport.
 */

var isInMobileViewport = function isInMobileViewport() {
  return window.innerWidth < MOBILE_BREAKPOINT;
};
/**
 * Detects device target.
 */


var detectDeviceTarget = function detectDeviceTarget(_a) {
  var desktop = _a.desktop,
      mobile = _a.mobile;
  return isInMobileViewport() ? mobile : desktop;
};

var isAndroid = typeof window !== 'undefined' ? /(android)/i.test(navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) : false;
var isIos = typeof window !== 'undefined' ? /iPad|iPhone|iPod/.test(navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) : false;
/**
 * Prevents event default behavior.
 */

var preventDefault = function preventDefault(event) {
  return event.preventDefault();
};

var _a$1, _b;

var COUNTRIES;

(function (COUNTRIES) {
  COUNTRIES["BRAZIL"] = "br";
  COUNTRIES["COLOMBIA"] = "co";
  COUNTRIES["MEXICO"] = "mx";
})(COUNTRIES || (COUNTRIES = {}));

var COUNTRY_LOCALE;

(function (COUNTRY_LOCALE) {
  COUNTRY_LOCALE["BRAZIL"] = "pt-BR";
  COUNTRY_LOCALE["COLOMBIA"] = "es-CO";
  COUNTRY_LOCALE["MEXICO"] = "es-MX";
})(COUNTRY_LOCALE || (COUNTRY_LOCALE = {}));

var COMPANIES;

(function (COMPANIES) {
  COMPANIES["IFOOD"] = "ifood";
  COMPANIES["SINDELANTAL"] = "sindelantal";
})(COMPANIES || (COMPANIES = {}));
/**
 * Country configurations.
 */


var COUNTRY_CONFIGS = (_a$1 = {}, _a$1[COUNTRIES.BRAZIL] = {
  applicationName: 'Portal do Parceiro',
  locale: COUNTRY_LOCALE.BRAZIL,
  canGiveFeedback: true
}, _a$1[COUNTRIES.COLOMBIA] = {
  applicationName: 'Portal de Aliados',
  locale: COUNTRY_LOCALE.COLOMBIA,
  canGiveFeedback: false
}, _a$1[COUNTRIES.MEXICO] = {
  applicationName: 'Portal del Restaurante',
  locale: COUNTRY_LOCALE.MEXICO,
  canGiveFeedback: false
}, _a$1);
/**
 * Company configurations.
 */

var COMPANY_CONFIGS = (_b = {}, _b[COMPANIES.IFOOD] = {
  name: 'iFood'
}, _b[COMPANIES.SINDELANTAL] = {
  name: 'Sindelantal'
}, _b);
/**
 * Get domain from hostname (default to current location hostname).
 */

var getDomain = function getDomain(hostname) {
  if (hostname === void 0) {
    hostname = typeof window === 'undefined' ? '' : window.location.hostname;
  }

  return hostname.replace(/^([^.]*)\./, '');
};
/**
 * Get domain country.
 */


var getDomainCountry = function getDomainCountry(hostname) {
  if (hostname === void 0) {
    hostname = window.location.hostname;
  }

  return hostname.includes('.') ? last$1(hostname.split('.')) : COUNTRIES.BRAZIL;
};
/**
 * Get domain company (default to current domain info).
 */


var getDomainCompany = function getDomainCompany(hostname) {
  if (hostname === void 0) {
    hostname = window.location.hostname;
  }

  return pipe(match(new RegExp([values(COMPANIES)].join('|'))), head, defaultTo(COMPANIES.IFOOD))(hostname);
};
/**
 * Get company configuration (default to current domain info).
 */


var getCompanyConfig = function getCompanyConfig(domainCompany) {
  if (domainCompany === void 0) {
    domainCompany = getDomainCompany();
  }

  return COMPANY_CONFIGS[domainCompany] || COMPANY_CONFIGS[COMPANIES.IFOOD];
};
/**
 * Get country configuration (default to current domain info).
 */


var getCountryConfig = function getCountryConfig(domainCountry) {
  if (domainCountry === void 0) {
    domainCountry = getDomainCountry();
  }

  return COUNTRY_CONFIGS[domainCountry] || COUNTRY_CONFIGS[COUNTRIES.BRAZIL];
};
/**
 * Get default locale (default to current domain info).
 */


var getDefaultLocale = function getDefaultLocale(countryConfig) {
  if (countryConfig === void 0) {
    countryConfig = getCountryConfig();
  }

  return countryConfig.locale;
};
/**
 * Get default page title (default to current domain info).
 */


var getDefaultPageTitle = function getDefaultPageTitle(companyConfig, countryConfig) {
  if (companyConfig === void 0) {
    companyConfig = getCompanyConfig();
  }

  if (countryConfig === void 0) {
    countryConfig = getCountryConfig();
  }

  return companyConfig.name + " - " + countryConfig.applicationName;
};
/**
 * Builds the service host (default to current location hostname).
 */


var getServiceHost = function getServiceHost(host, domain) {
  if (domain === void 0) {
    domain = getDomain();
  }

  return host ? host.replace('{DOMAIN}', domain) : '';
};
/**
 * Builds the service URL from the host, port and path (default to current location hostname).
 */


var getServiceURL = function getServiceURL(host, port, path, domain) {
  if (domain === void 0) {
    domain = getDomain();
  }

  return getServiceHost(host, domain) + ":" + port + "/" + path;
};
/**
 * Builds the service URL from environment process object and env. prefix name.
 */


var getServiceURLByEnv = curry(function (env, prefix) {
  var host = env[prefix + "_HOST"];
  var port = env[prefix + "_PORT"];
  var path = env[prefix + "_PATH"];
  return getServiceURL(host, port, path);
});
/**
 * Returns the max length for a phone field.
 */

var getLocalePhoneMaxLength = function getLocalePhoneMaxLength(locale) {
  switch (locale) {
    case COUNTRY_LOCALE.BRAZIL:
      return 15;

    default:
      return null;
  }
};
/**
 * Returns the max length for a phone field.
 * @deprecated Use `getLocalePhoneMaxLength`
 */


var validatePhoneMaxLength = getLocalePhoneMaxLength;
var UNEXPECTED_ERROR = 'unexpected-error';
/**
 * Get error stack.
 */

var getStack = prop('stack');
/**
 * Checks if two error are equal.
 */

var errorEquals = function errorEquals(a, b) {
  return equals(getStack(a), getStack(b));
};

var lastError;

var errorHandler = function errorHandler(error, getState, lastAction, dispatch) {
  // eslint-disable-next-line no-console
  console.error(error);

  if (errorEquals(error, lastError)) {
    return;
  }

  lastError = error;
  var type = UNEXPECTED_ERROR;
  var message = error.stack;
  dispatch(Notifications.error({
    uid: type,
    message: "error.request." + type,
    autoDismiss: 0
  }));
  dispatch({
    type: type,
    error: error,
    message: message
  });
};

var eventMapping = new WeakMap();
/**
 * Register a new event handler at 'eventMapping' object. Avoid duplicates.
 */

var registerEvent = function registerEvent(eventName, registerKey, handler) {
  var _a;

  if (!eventName || !registerKey || !handler) {
    return;
  }

  var register = eventMapping.get(registerKey);

  if (isNil(register) || isNil(register[eventName])) {
    eventMapping.set(registerKey, _assign(_assign({}, eventMapping.get(registerKey)), (_a = {}, _a[eventName] = function (event) {
      handler(event);
    }, _a)));
    document.addEventListener(eventName, eventMapping.get(registerKey)[eventName], false);
  }
};
/**
 * Unregister an event handler from 'eventMapping' object.
 */


var unregisterEvent = function unregisterEvent(eventName, registerKey) {
  var register = eventMapping.get(registerKey);

  if (register && register[eventName]) {
    document.removeEventListener(eventName, register[eventName]);
    delete register[eventName];

    if (isNil(eventMapping.get(registerKey)) || isEmpty(eventMapping.get(registerKey))) {
      eventMapping.delete(registerKey);
    }
  }
};

var FILE_SIZE_PREFIXES_ENUM;

(function (FILE_SIZE_PREFIXES_ENUM) {
  FILE_SIZE_PREFIXES_ENUM["BYTES"] = "B";
  FILE_SIZE_PREFIXES_ENUM["KILOBYTES"] = "KB";
  FILE_SIZE_PREFIXES_ENUM["GIGABYTES"] = "GB";
  FILE_SIZE_PREFIXES_ENUM["MEGABYTES"] = "MB";
})(FILE_SIZE_PREFIXES_ENUM || (FILE_SIZE_PREFIXES_ENUM = {}));

var FILE_SIZE_PREFIXES = [FILE_SIZE_PREFIXES_ENUM.BYTES, FILE_SIZE_PREFIXES_ENUM.KILOBYTES, FILE_SIZE_PREFIXES_ENUM.MEGABYTES, FILE_SIZE_PREFIXES_ENUM.GIGABYTES];
/**
 * Opens a link.
 */

var openLink = function openLink(anchor) {
  document.body.appendChild(anchor);
  anchor.click();
  setTimeout(function () {
    return document.body.removeChild(anchor);
  }, 8000);
};
/**
 * Creates an download anchor.
 */


var createDownloadLink = function createDownloadLink(href, download) {
  var anchor = document.createElement('a');
  anchor.setAttribute('href', href);
  anchor.setAttribute('download', download);
  return anchor;
};
/**
 * Downloads a file.
 */


var downloadFile = function downloadFile(response, fileName) {
  var blob = new Blob([response.data], {
    type: response.headers['content-type'] || 'application/octet-stream'
  });
  var link = createDownloadLink(URL.createObjectURL(blob), fileName);
  openLink(link);
};
/**
 * Converts file size to prettier format.
 */


var prettierFileSize = function prettierFileSize(size) {
  var result = size;
  var index;

  for (index = 0; result >= 1024; index += 1) {
    result /= 1024;
  }

  return {
    value: result,
    unit: FILE_SIZE_PREFIXES[index]
  };
};
/**
 * Returns rounded overloaded file size, ready to send to google analytics event.
 */


var getOverloadedFileSize = function getOverloadedFileSize(size, limit) {
  var result = Math.floor((size - limit) / 1024 / 1024);

  if (result < 1) {
    return '<1mb';
  } else if (result > 5) {
    return '>5mb';
  }

  return ">" + result + "mb";
};
/**
 * Starts automatic file download.
 */


var automaticDownloadFile = function automaticDownloadFile(path) {
  var link = createDownloadLink(path, path.substr(path.lastIndexOf(' / ') + 1));
  openLink(link);
};
/**
 * Opens a link in a new tab.
 */


var openLinkInNewTab = function openLinkInNewTab(path) {
  var link = createDownloadLink(path, path.substr(path.lastIndexOf(' / ') + 1));
  link.setAttribute('target', '_blank');
  openLink(link);
};
/**
 * Downloads an external file by url.
 */


var saveFileURL = function saveFileURL(url, fileName, fileType) {
  var request = new XMLHttpRequest();
  return new Promise(function (resolve, reject) {
    request.open('GET', url, true);
    request.responseType = 'blob';

    request.onload = function (e) {
      var file = new Blob([request.response], {
        type: fileType
      });
      var link = createDownloadLink(URL.createObjectURL(file), fileName);
      openLink(link);
      resolve(e);
    };

    request.send();
    request.onerror = reject;
  });
};
/**
 * Toggle item in object.
 */


var toggleObjectItem = function toggleObjectItem(obj, key, item) {
  var _a;

  return obj[key] !== undefined ? omit([key], obj) : _assign(_assign({}, obj), (_a = {}, _a[key] = item, _a));
};
/**
 * Shallow difference between two objects.
 */


var shallowDifference = function shallowDifference(a, b) {
  return keys(b).filter(function (prop) {
    return prop in a;
  }).filter(function (prop) {
    return a[prop] !== b[prop];
  }).reduce(function (diff, prop) {
    var _a;

    return _assign(_assign({}, diff), (_a = {}, _a[prop] = b[prop], _a));
  }, {});
};
/**
 * Rename object keys.
 */


var renameObjectKeys = function renameObjectKeys(keysMap, obj) {
  return reduce(function (acc, key) {
    return assoc(keysMap[key] || key, obj[key], acc);
  }, {}, keys(obj));
};
/**
 * Checks if all values satisfies a given function.
 */


var allValuesSatisfies = function allValuesSatisfies(fn) {
  return pipe(values, all(fn));
};
/**
 * Checks if any values satisfies a given function.
 */


var anyValuesSatisfies = function anyValuesSatisfies(fn) {
  return pipe(values, any(fn));
};
/**
 * Checks if length satisfies a given function.
 */


var lengthSatisfies = function lengthSatisfies(fn) {
  return pipe(size, fn);
};

var isString = is(String);

var isStringPresent = function isStringPresent(value) {
  return /\S/.test(value);
};

var isStringNotEmpty = function isStringNotEmpty(value) {
  return isString(value) ? isStringPresent(value) : true;
};
/**
 * Converts string to lower case.
 */


var toLowerCase = pipe(String, toLower);
/**
 * Converts string to upper case.
 */

var toUpperCase = pipe(String, toUpper);
/**
 * Convert kebab-case to CONSTANT_CASE.
 */

var fromKebabToConstantCase = pipe(toUpperCase, split('-'), join('_'));
/**
 * Checks if two strings are equal ignoring the case.
 */

var eqIgnoringCase = curry(function (a, b) {
  return toLowerCase(a) === toLowerCase(b);
});
/**
 * Checks if a string includes the other ignoring the case.
 */

var includesIgnoringCase = curry(function (a, b) {
  return toLowerCase(b).includes(toLowerCase(a));
});
/**
 * Removes accents from a string.
 */

var removeAccents = function removeAccents(value) {
  return remove(value);
};
/**
 * Removes accents and converts to upper case.
 */


var removeAccentsAndUpperCase = pipe(defaultTo(''), removeAccents, toUpperCase);
/**
 * Checks if a string has only numbers.
 */

var hasOnlyNumbers = test(/^((?:-?(?:(?:\d+|\d*\.\d+)(?:[E|e][+|-]?\d+)?)))$/);
/**
 * Checks if a string has numbers.
 */

var hasNumbers = test(/\d/);
/**
 * Checks if string has lower case characters.
 */

var hasLowerCaseCharacters = test(/[a-z]/);
/**
 * Checks if string has upper case characters.
 */

var hasUpperCaseCharacters = test(/[A-Z]/);
/**
 * Checks if value starts with any of the provided options.
 */

var startsWithAny = function startsWithAny(value) {
  var options = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    options[_i - 1] = arguments[_i];
  }

  return options.some(function (option) {
    return value.startsWith(option);
  });
};
/**
 * Checks if value matches any pattern.
 */


var matchesAny = function matchesAny(patterns) {
  return function (value) {
    return patterns.some(function (pattern) {
      return pattern.exec(value);
    });
  };
};
/**
 * Checks if a CPF string is valid.
 */


var isCPFValid = function isCPFValid(value) {
  var normalized = value.replace(/[^\d\w]+/g, '');
  var sum = 0;
  var remainder = 0;
  if (!normalized || normalized === '00000000000' || normalized.length !== 11) return false;

  for (var i = 1; i <= 9; i += 1) {
    sum += parseInt(normalized.substring(i - 1, i), 10) * (11 - i);
  }

  remainder = sum * 10 % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(normalized.substring(9, 10), 10)) return false;
  sum = 0;

  for (var i = 1; i <= 10; i += 1) {
    sum += parseInt(normalized.substring(i - 1, i), 10) * (12 - i);
  }

  remainder = sum * 10 % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(normalized.substring(10, 11), 10)) return false;
  return true;
};
/**
 * Checks if a CNPJ string is valid.
 */


var isCNPJValid = function isCNPJValid(value) {
  var normalized = value.replace(/[^\d\w]+/g, '');

  if (normalized.length !== 14 || /^(\d)\1+$/.test(normalized)) {
    return false;
  }

  var length = normalized.length - 2;
  var chars = normalized.substring(0, length);
  var digits = normalized.substring(length);
  var sum = 0;
  var pos = length - 7;

  for (var i = length; i >= 1; i -= 1) {
    sum += Number(chars.charAt(length - i)) * pos;
    pos -= 1;
    if (pos < 2) pos = 9;
  }

  var result = sum % 11 < 2 ? 0 : 11 - sum % 11;
  if (result != Number(digits.charAt(0))) return false; // eslint-disable-line eqeqeq

  length += 1;
  chars = normalized.substring(0, length);
  sum = 0;
  pos = length - 7;

  for (var i = length; i >= 1; i -= 1) {
    sum += Number(chars.charAt(length - i)) * pos;
    pos -= 1;
    if (pos < 2) pos = 9;
  }

  result = sum % 11 < 2 ? 0 : 11 - sum % 11;
  if (result != Number(digits.charAt(1))) return false; // eslint-disable-line eqeqeq

  return true;
};
/**
 * Checks if a value is not present.
 */


var isNotPresent = anyPass([isNil, equals('')]);
/**
 * Checks if a value is present.
 */

var isPresent = complement(isNotPresent);
/**
 * Checks if a value is a pair.
 */

var isPair = lengthSatisfies(equals(2));
/**
 * Checks if a pair is not present.
 */

var isPairNotPresent = anyValuesSatisfies(isNotPresent);
/**
 * Runs a function against normalized pair keys.
 */

var runWithNormalizedKeys = function runWithNormalizedKeys(fn) {
  return pipe(values, zipObj(['from', 'to']), fn);
};
/**
 * Checks if the parameter is a valid error message.
 */


var isErrorMessage = allPass([complement(isNil), has('message')]);
/**
 * Builds an error message.
 */

var buildErrorMessage = function buildErrorMessage(message, values) {
  return {
    message: message,
    values: values
  };
};
/**
 * Validates a value (if present) according to a given function.
 */


var validate = function validate(fn, errorMessage) {
  return cond([[either(isNotPresent, fn), always(undefined)], [T, always(errorMessage)]]);
};
/**
 * Validates a value according to a given function.
 *
 * @deprecated Validation rules should bypass undefined values. Use `validateRequired` along with `validate` in order to enforce value presence.
 */


var validateStrict = function validateStrict(fn, errorMessage) {
  return function (value) {
    return !fn(value) ? errorMessage : undefined;
  };
};
/**
 * Validates a pair of values (if present) according to a given function.
 */


var validatePair = function validatePair(fn, errorMessage) {
  return cond([[complement(isPair), always({})], [isPairNotPresent, always({})], [runWithNormalizedKeys(fn), always({})], [T, mapObjIndexed(always(errorMessage))]]);
};
/**
 * Validates a pair of values according to a given function.
 *
 * @deprecated Validation rules should bypass undefined values. Use `validateRequired` along with `validate` in order to enforce value presence.
 */


var validateStrictPair = function validateStrictPair(fn, errorMessage) {
  return cond([[complement(isPair), always({})], [runWithNormalizedKeys(fn), always({})], [T, mapObjIndexed(always(errorMessage))]]);
};
/**
 * Checks if value is filled (counting blank spaces). Only works for strings, numbers, checkboxes.
 */


var validateRequired = validateStrict(allPass([isStringNotEmpty, isPresent]), buildErrorMessage('error.validation.required-fields'));
/**
 * Checks if value is not empty.
 */

var validateNotEmpty = validateStrict(lengthSatisfies(lt(0)), buildErrorMessage('error.validation.required-fields'));
/**
 * Handle submit failure.
 */

var handleSubmitFail = function handleSubmitFail(errors, dispatch, submitError, props) {
  if (submitError) {
    console.error(submitError); // eslint-disable-line no-console
  }

  if (submitError || props.error) {
    return dispatch(Notifications.error({
      uid: props.form,
      message: props.error || 'error.form',
      autoDismiss: 0
    }));
  }

  var messages = uniq(map(errors, function (error) {
    return isErrorMessage(error) ? error.message : error;
  }));
  var values = uniq(map(errors, function (error) {
    return error.values;
  }));
  return dispatch(Notifications.error({
    uid: props.form,
    message: first(messages) || 'error.form',
    values: first(values),
    autoDismiss: 0
  }));
};
/**
 * Checks if a value is positive.
 */


var isPositive = lt(0);
/**
 * Checks if a value is negative.
 */

var isNegative = gt(0);
/**
 * Checks if a value is between a range.
 */

var isBetween = function isBetween(min, max, value) {
  return lte(min, value) && gte(max, value);
};
/**
 * Truncates a number to a given number of digits.
 */


var truncate = function truncate(value, digits) {
  if (digits === void 0) {
    digits = 2;
  }

  return Math.floor(value * Math.pow(10, digits)) / Math.pow(10, digits);
};
/**
 * Normalizes a value between `min` and `max` from 0 to 1.
 */


var normalize = function normalize(value, min, max) {
  return (value - min) / (max - min);
};
/**
 * Rounds a number to its nearest multiple.
 */


var roundToNearestMultiple = function roundToNearestMultiple(n, multiple) {
  var remainder = n % multiple;
  return remainder <= multiple / 2 ? n - remainder : n + multiple - remainder;
};

var TIME_UNIT;

(function (TIME_UNIT) {
  TIME_UNIT["hours"] = "hours";
  TIME_UNIT["minutes"] = "minutes";
  TIME_UNIT["seconds"] = "seconds";
})(TIME_UNIT || (TIME_UNIT = {}));
/**
 * Delays a function with a given wait in milliseconds.
 */


var delay = curry(function (wait, result) {
  return new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve(result);
    }, wait);
  });
});
/**
 * Builds a time.
 */

var buildTime = function buildTime(hours, minutes, seconds) {
  if (seconds === void 0) {
    seconds = 0;
  }

  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

var dayStartTime = buildTime(0, 0);
var dayEndTime = buildTime(23, 59);
/**
 * Checks if the parameter is a valid time.
 *
 * @param {Time} Time
 * @returns {boolean} True if the parameter is a valid time
 */

var isTime = allPass([complement(isNil), has('hours'), has('minutes'), propSatisfies(gte(60), 'minutes')]);
/**
 * Calculates the time in hours.
 */

var timeToHours = function timeToHours(time) {
  return time.hours;
};
/**
 * Calculates the time in minutes.
 */


var timeToMinutes = function timeToMinutes(time) {
  return timeToHours(time) * 60 + time.minutes;
};
/**
 * Calculates the time in seconds.
 */


var timeToSeconds = function timeToSeconds(time) {
  return timeToMinutes(time) * 60 + (time.seconds || 0);
};
/**
 * Calculates two times difference in seconds.
 */


var timeDiff = function timeDiff(a, b, unit) {
  switch (unit) {
    case TIME_UNIT.hours:
      return timeToHours(b) - timeToHours(a);

    case TIME_UNIT.minutes:
      return timeToMinutes(b) - timeToMinutes(a);

    default:
      return timeToSeconds(b) - timeToSeconds(a);
  }
};
/**
 * Checks if a time is equal to a given time.
 */


var timeEq = function timeEq(_a) {
  var hours = _a.hours,
      minutes = _a.minutes;
  return allPass([isTime, propEq('hours', hours), propEq('minutes', minutes)]);
};
/**
 * Calculates the minimum time between two ones.
 */


var minTime = minBy(timeToSeconds);
/**
 * Calculates the maximum time between two ones.
 *
 * @param {Time} timeA - First time
 * @param {Time} timeB - Second time
 * @returns {Time} Maximum time
 */

var maxTime = maxBy(timeToSeconds);
/**
 * Checks if a time is the day start.
 */

var isDayStartTime = timeEq(dayStartTime);
/**
 * Checks if a time is the day end.
 */

var isDayEndTime = timeEq(dayEndTime);
/**
 * Converts a moment to time.
 */

var momentToTime = function momentToTime(value) {
  return buildTime(Math.floor(value.hours()), value.minutes());
};
/**
 * Converts a moment to time.
 * @deprecated Use `momentToTime`
 */


var momentToLimit = momentToTime;
/**
 * Convert Moment to Java time period.
 */

var momentToTimePeriod = function momentToTimePeriod(value) {
  return [value.hours(), value.minutes(), value.seconds()];
};
/**
 * Converts Java time period to Moment.
 */


var timePeriodToMoment = function timePeriodToMoment(period) {
  return moment$1.utc(period.slice(0, 2).join(':'), 'h:mm');
};
/**
 * Converts a time array to moment.
 */


var timePeriodToNowMoment = function timePeriodToNowMoment(_a) {
  var hours = _a[0],
      minutes = _a[1];
  return now().clone().set('hours', hours).set('minutes', minutes);
};
/**
 * Converts a time period to time.
 */


var timePeriodToTime = function timePeriodToTime(_a) {
  var hours = _a[0],
      minutes = _a[1];
  return {
    hours: hours,
    minutes: minutes
  };
};
/**
 * Converts a time period to time.
 * @deprecated Use `timePeriodToTime`
 */


var timePeriodToLimit = timePeriodToTime;
/**
 * Converts duration to moment.
 */

var durationToUTCMoment = function durationToUTCMoment(duration) {
  var minutes = duration.asMinutes();
  return timePeriodToMoment([minutes / 60, minutes % 60]);
};
/**
 * Converts minutes to moment duration (mutable instance).
 *
 * @see https://momentjs.com/docs/#/durations/
 */


var minutesToDuration = function minutesToDuration(minutes) {
  return moment$1.duration(minutes, 'minutes');
};
/**
 * Converts seconds to moment duration (mutable instance).
 *
 * @see https://momentjs.com/docs/#/durations/
 */


var secondsToDuration = function secondsToDuration(seconds) {
  return moment$1.duration(seconds, 'seconds');
};
/**
 * Formats seconds to duration.
 */


var formatSecondsDuration = function formatSecondsDuration(seconds) {
  return secondsToDuration(seconds).format('H[h]mm[min]');
};
/**
 * Formats minutes to duration.
 */


var formatMinutesDuration = function formatMinutesDuration(minutes) {
  return moment$1.duration(minutes, 'minutes').format('H[h]mm[min]');
};
/**
 * Convert a Number to its ISO time only format.
 * @deprecated Use `formatMinutesDuration`
 */


var formatMinutesDurationToISOTime = formatMinutesDuration;
/**
 * Formats hours open to text to be displayed.
 */

var formatTimeToText = function formatTimeToText(hours) {
  var h = Math.floor(hours);
  var m = roundToNearestMultiple(Math.round((hours - Math.floor(hours)) * 60), 15);

  if (m >= 60) {
    h += 1;
    m -= 60;
  }

  return m < 1 ? h + "h" : h + "h" + (m < 10 ? "0" + m : m);
};

var moment = extendMoment(moment$1);
/**
 * Builds a shift.
 */

var buildShift = function buildShift(openingTime, closingTime) {
  return {
    openingTime: openingTime,
    closingTime: closingTime
  };
};
/**
 * Builds a time shift.
 */


var buildTimeShift = buildShift;
var dayShift = buildTimeShift(dayStartTime, dayEndTime);
/**
 * Builds a moment shift.
 */

var buildMomentShift = buildShift;
/**
 * Checks if a shift is valid.
 */

var isShift = allPass([complement(isNil), has('openingTime'), has('closingTime')]);
/**
 * Checks if a shift is complete.
 */

var isShiftComplete = allPass([isShift, propSatisfies(complement(isNil), 'openingTime'), propSatisfies(complement(isNil), 'closingTime')]);
/**
 * Checks if a shift is overnight.
 */

var isShiftOvernight = function isShiftOvernight(_a) {
  var openingTime = _a.openingTime,
      closingTime = _a.closingTime;
  return timeToSeconds(closingTime) < timeToSeconds(openingTime);
};
/**
 * Checks if a custom moment range instantaneous within a time period.
 */


var isCustomMomentRangeInstantaneous = function isCustomMomentRangeInstantaneous(unit, period) {
  if (period === void 0) {
    period = 0;
  }

  return function (_a) {
    var from = _a.from,
        to = _a.to;
    return to.diff(from, unit) === period;
  };
};
/**
 * Checks if a custom moment range is valid and possible.
 */


var isCustomMomentRangeValid = function isCustomMomentRangeValid(unit) {
  return function (_a) {
    var from = _a.from,
        to = _a.to;
    return to.diff(from, unit) > 0;
  };
};
/**
 * Checks if a custom moment range is valid and possible within a time period.
 */


var isCustomMomentRangeValidWithinPeriod = function isCustomMomentRangeValidWithinPeriod(unit, period) {
  return function (_a) {
    var from = _a.from,
        to = _a.to;
    return isCustomMomentRangeValid(unit) && to.diff(from, unit) <= period;
  };
};
/**
 * Checks if two moment shifts are equal.
 */


var areShiftsEqual = function areShiftsEqual(a, b) {
  return a.openingTime.isSame(b.openingTime) && a.closingTime.isSame(b.closingTime);
};
/**
 * Checks if two time shifts are adjacent.
 */


var areShiftsAdjacent = function areShiftsAdjacent(a, b) {
  return timeDiff(a.closingTime, b.openingTime) === -1;
};
/**
 * Checks if two time shifts intersects.
 */


var areShiftsIntersected = function areShiftsIntersected(a, b) {
  return maxTime(a.openingTime, a.closingTime) >= minTime(b.openingTime, b.closingTime) && minTime(a.openingTime, a.closingTime) <= maxTime(b.openingTime, b.closingTime);
};
/**
 * Checks if two moment shift times are equal.
 */


var areMomentShiftTimesEqual = function areMomentShiftTimesEqual(a) {
  return function (b) {
    return equals(momentToTimePeriod(a.openingTime), momentToTimePeriod(b.openingTime)) && equals(momentToTimePeriod(a.closingTime), momentToTimePeriod(b.closingTime));
  };
};
/**
 * Build an intesection between two moment shifts.
 */


var intersectShifts = function intersectShifts(a, b) {
  return moment.max(a.openingTime, b.openingTime) < moment.min(a.closingTime, b.closingTime) ? buildMomentShift(moment.max(a.openingTime, b.openingTime), moment.min(a.closingTime, b.closingTime)) : null;
};
/**
 * Calculates the minimum opening time between two shifts.
 */


var minShiftOpeningTime = function minShiftOpeningTime(a, b) {
  return minTime(a.openingTime, b.openingTime);
};
/**
 * Calculates the maximum opening time between two shifts.
 */


var maxShiftClosingTime = function maxShiftClosingTime(a, b) {
  return maxTime(a.closingTime, b.closingTime);
};
/**
 * Sorts two shifts.
 */


var sortTwoShifts = function sortTwoShifts(a, b) {
  return timeDiff(a.openingTime, b.openingTime);
};
/**
 * Sorts a list of shifts.
 */


var sortShifts = sort(sortTwoShifts);
/**
 * Converts time periods to time shift.
 */

var timePeriodsToTimeShift = function timePeriodsToTimeShift(_a) {
  var openingTime = _a.openingTime,
      closingTime = _a.closingTime;
  return buildTimeShift(timePeriodToTime(openingTime), timePeriodToTime(closingTime));
};
/**
 * Converts time periods to moment shift.
 */


var timePeriodsToMomentShift = function timePeriodsToMomentShift(_a) {
  var openingTime = _a.openingTime,
      closingTime = _a.closingTime;
  return buildMomentShift(timePeriodToMoment(openingTime), timePeriodToMoment(closingTime));
};
/**
 * Converts time range to time shift.
 */


var timeRangeToShift = function timeRangeToShift(_a) {
  var openingTime = _a[0],
      closingTime = _a[1];
  return buildShift(openingTime, closingTime);
};
/**
 * Converts time shift to time range.
 */


var shiftToTimeRange = function shiftToTimeRange(_a) {
  var openingTime = _a.openingTime,
      closingTime = _a.closingTime;
  return [openingTime, closingTime];
};
/**
 * Converts moment shift to moment range.
 */


var shiftToMomentRange = function shiftToMomentRange(shift) {
  return moment.range(shift.openingTime, shift.closingTime);
};
/**
 * Converts moment range to shift.
 */


var momentRangeToShift = function momentRangeToShift(momentRange) {
  return {
    closingTime: momentRange.end,
    openingTime: momentRange.start
  };
};
/**
 * Calculates a shift duration in the given unit.
 */


var shiftDuration = function shiftDuration(unit) {
  if (unit === void 0) {
    unit = 'hours';
  }

  return function (_a) {
    var openingTime = _a.openingTime,
        closingTime = _a.closingTime;
    return moment.duration(closingTime.diff(openingTime)).as(unit);
  };
};
/**
 * Merges two time shifts.
 */


var mergeShifts = function mergeShifts(a, b) {
  return buildShift(minShiftOpeningTime(a, b), maxShiftClosingTime(a, b));
};
/**
 * Merges adjacent shifts.
 */


var mergeAdjacentShifts = function mergeAdjacentShifts(shifts) {
  var clonedShifts = __spreadArrays(shifts);

  for (var i = 0; i < clonedShifts.length - 1; i += 1) {
    var current = clonedShifts[i];
    var next = clonedShifts[i + 1];

    if (areShiftsAdjacent(current, next) || areShiftsIntersected(current, next)) {
      clonedShifts.splice(i + 1, 1);
      clonedShifts[i] = mergeShifts(current, next);
      i -= 1;
    }
  }

  return clonedShifts;
};
/**
 * Splits shifts if a shift is past midnight.
 */


var splitShiftsPastMidnight = function splitShiftsPastMidnight(shift) {
  return isShiftOvernight(shift) ? [buildShift(shift.openingTime, dayEndTime), buildShift(dayStartTime, shift.closingTime)] : [shift];
};
/**
 * Builds pickers.
 */


var buildPickers = function buildPickers(date, time) {
  return {
    date: date,
    time: time
  };
};
/**
 * Checks if pickers are valid.
 */


var isPickers = function isPickers(pickers) {
  return pickers && isMoment(pickers.date) && isMoment(pickers.time);
};
/**
 * Checks if pickers range is valid.
 */


var isPickersRange = function isPickersRange(_a) {
  var from = _a.from,
      to = _a.to;
  return isPickers(from) && isPickers(to);
};
/**
 * Converts pickers to a date time period.
 */


var pickersToDateTimePeriod = function pickersToDateTimePeriod(_a) {
  var date = _a.date,
      time = _a.time;
  return __spreadArrays(date ? momentToDatePeriod(date) : [], time ? momentToTimePeriod(time) : []);
};
/**
 * Converts pickers date and time to moment.
 */


var pickersToMoment = function pickersToMoment(_a) {
  var date = _a.date,
      time = _a.time;
  return moment$1([date.year(), date.month(), date.date(), time.hour(), time.minute(), time.second()]);
};
/**
 * Converts pickers range to custom moment range.
 */


var pickersRangeToCustomMomentRange = function pickersRangeToCustomMomentRange(_a) {
  var from = _a.from,
      to = _a.to;
  return {
    from: pickersToMoment(from),
    to: pickersToMoment(to)
  };
};
/**
 * Generate time options as multi shift.
 */


var generateTimeOptionsAsMultiShift = function generateTimeOptionsAsMultiShift(interval, ranges, shouldShowOption) {
  if (shouldShowOption === void 0) {
    shouldShowOption = identity;
  }

  var timeSeries = [];
  var lastDayTimeDuration = moment$1.duration(dayEndTime);
  ranges.forEach(function (range) {
    var current = moment$1.duration(head(range));
    var end = moment$1.duration(last$1(range));

    while (current.asSeconds() < end.asSeconds()) {
      timeSeries.push(durationToUTCMoment(current));
      current.add(interval, 'm');
    }

    var shouldCloseRangeAtEndOfDay = end.asSeconds() === lastDayTimeDuration.asSeconds();
    var lastRangeEqualsEndRange = current.asSeconds() === end.asSeconds();
    var lastRangeOffByOneMinute = current.asSeconds() - end.asSeconds() === 60;
    var shouldCloseTimeSeriesWithEndRange = lastRangeOffByOneMinute || lastRangeEqualsEndRange;

    if (shouldCloseTimeSeriesWithEndRange) {
      timeSeries.push(durationToUTCMoment(end));
    } else if (shouldCloseRangeAtEndOfDay) {
      timeSeries.push(durationToUTCMoment(lastDayTimeDuration));
    }
  });
  return filter(shouldShowOption, timeSeries);
};
/**
 * Generate time options.
 */


var generateTimeOptions = function generateTimeOptions(interval, timeRange, shouldShowOption) {
  if (shouldShowOption === void 0) {
    shouldShowOption = identity;
  }

  var timeSeries = [];
  var lastDayTimeDuration = moment$1.duration(dayEndTime);
  var ranges = pipe(timeRangeToShift, splitShiftsPastMidnight, map$1(shiftToTimeRange))(timeRange);
  ranges.forEach(function (range) {
    var current = moment$1.duration(head(range));
    var end = moment$1.duration(last$1(range));

    while (current.asSeconds() < end.asSeconds()) {
      timeSeries.push(durationToUTCMoment(current));
      current.add(interval, 'm');
    }

    if (end.asSeconds() === lastDayTimeDuration.asSeconds()) {
      timeSeries.push(durationToUTCMoment(lastDayTimeDuration));
    }

    if (current.asHours() < 24) {
      timeSeries.push(durationToUTCMoment(current));
    }
  });
  return filter(shouldShowOption, timeSeries);
};
/**
 * Checks if a moment pair is not present.
 */


var isMomentPairNotPresent = anyValuesSatisfies(complement(isMoment));
/**
 * Checks if value is a moment date.
 */

var validateDate = validate(isMoment, buildErrorMessage('error.validation.invalid-date'));
/**
 * Checks if date range is present.
 */

var validateRequiredDateRange = validateStrict(pipe(defaultTo([]), lengthSatisfies(equals(2)), all(isPresent)), buildErrorMessage('error.validation.required-fields'));
/**
 * Checks if custom moment range is valid.
 */

var validateMomentRange = function validateMomentRange(value, unit, errorMessage) {
  if (errorMessage === void 0) {
    errorMessage = 'error.validation.invalid-date-range';
  }

  return validatePair(either(isMomentPairNotPresent, isCustomMomentRangeValid(unit)), buildErrorMessage(errorMessage))(value);
};
/**
 * Checks if date range is within specified period.
 */


var validateMomentRangeWithinPeriod = function validateMomentRangeWithinPeriod(value, unit, period, durationMessage) {
  return validatePair(either(isMomentPairNotPresent, isCustomMomentRangeValidWithinPeriod(unit, period)), buildErrorMessage('error.validation.range-exceeds-period', {
    type: durationMessage,
    interval: period
  }))(value);
};
/**
 * Checks if date range is not instantaneous.
 */


var validateMomentRangeNotInstantaneous = function validateMomentRangeNotInstantaneous(value, errorMessage) {
  if (errorMessage === void 0) {
    errorMessage = 'error.validation.cannot-be-equal';
  }

  return validatePair(either(isMomentPairNotPresent, complement(isCustomMomentRangeInstantaneous())), buildErrorMessage(errorMessage))(value);
};
/**
 * Checks if shift range is valid.
 */


var validateShiftRange = function validateShiftRange(value, errorMessage) {
  if (errorMessage === void 0) {
    errorMessage = 'error.validation.invalid-date-range';
  }

  var instantaneousShiftError = validateMomentRangeNotInstantaneous(value);

  if (!isNil(instantaneousShiftError) && !isEmpty(instantaneousShiftError)) {
    return instantaneousShiftError;
  }

  return validateMomentRange(value, 'minutes', errorMessage);
};
/**
 * Checks if pickers range is valid.
 */


var validatePickersRange = function validatePickersRange(value, unit, errorMessage) {
  if (errorMessage === void 0) {
    errorMessage = 'error.validation.invalid-date-range';
  }

  return validatePair(either(complement(isPickersRange), pipe(pickersRangeToCustomMomentRange, isCustomMomentRangeValid(unit))), {
    date: buildErrorMessage(errorMessage),
    time: buildErrorMessage(errorMessage)
  })(value);
};

var imageShape = PropTypes.shape({
  baseUrl: PropTypes.string,
  path: PropTypes.string
});
/**
 * Builds an image.
 */

var buildImage = function buildImage(baseUrl, path) {
  return {
    baseUrl: baseUrl,
    path: path
  };
};
/**
 * Checks if the parameter is a valid image.
 */


var isImage = allPass([complement(isNil), has('baseUrl'), has('path')]);
/**
 * Get the image URL suitable for the Highlight component, using cloudinary transformations.
 */

var getHighlightImageURL = function getHighlightImageURL(url) {
  if (!url || url.indexOf('static-images.ifood.com.br') === -1) {
    return url;
  }

  var newURL = url.split('/');
  newURL[newURL.length - 3] = 'c_thumb,w_1024,h_350,t_high,f_auto';
  return newURL.join('/');
};
/**
 * Get the image URL suitable for the Card component, using cloudinary transformations.
 */


var getCardImageURL = function getCardImageURL(url) {
  if (!url || url.indexOf('static-images.ifood.com.br') === -1) {
    return url;
  }

  var newURL = url.split('/');
  newURL[newURL.length - 3] = 'c_thumb,w_270,h_160,t_medium,f_auto';
  return newURL.join('/');
};
/**
 * Gets image URL.
 */


var getImageURL = function getImageURL(image) {
  return "" + image.baseUrl + image.path;
};
/**
 * Gets image file name.
 */


var getImageFileName = function getImageFileName(imagePath) {
  return imagePath.substring(imagePath.lastIndexOf('/') + 1);
};
/**
 * Converts base64 to blob.
 */


var b64toBlob = function b64toBlob(b64Data, contentType, sliceSize) {
  if (contentType === void 0) {
    contentType = '';
  }

  if (sliceSize === void 0) {
    sliceSize = 512;
  }

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);

    for (var i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, {
    type: contentType
  });
};
/**
 * Checks if image is filled.
 */


var validateRequiredImage = validateStrict(isImage, buildErrorMessage('error.validation.required-fields'));
/**
 * Checks if logo image is filled.
 */

var validateRequiredLogoImage = validateStrict(isImage, buildErrorMessage('error.validation.required-logo'));
/**
 * Checks if value is a number.
 */

var validateNumber = validate(pipe(Number, complement(Number.isNaN)), buildErrorMessage('error.validation.numbers-only'));
/**
 * Checks if value has only numbers.
 */

var validateOnlyNumbers = validateStrict(hasOnlyNumbers, buildErrorMessage('error.validation.numbers-only'));
/**
 * Checks if value is positive.
 */

var validatePositive = either(validateNumber, validate(lte(0), buildErrorMessage('error.validation.positive-only')));
/**
 * Checks if value is below max.
 */

var validateMax = function validateMax(max) {
  return either(validateNumber, validate(gte(max), buildErrorMessage('error.validation.number-exceeds-max', {
    max: max
  })));
};
/**
 * Checks if value is above min.
 */


var validateMin = function validateMin(min) {
  return either(validateNumber, validate(lte(min), buildErrorMessage('error.validation.number-exceeds-min', {
    min: min
  })));
};
/**
 * Checks if value is above exact min with different message.
 */


var validateMinInteger = function validateMinInteger(min) {
  return either(validateNumber, validate(lte(min), buildErrorMessage('error.validation.number-exceeds-min-integer', {
    min: min - 1
  })));
};
/**
 * Checks if value is below max currency.
 */


var validateMaxCurrency = function validateMaxCurrency(max) {
  return pipe(prop('value'), validateMax(max));
};
/**
 * Checks if value is an order number.
 */


var validateOrderNumber = validate(lengthSatisfies(equals(4)), buildErrorMessage('error.validation.invalid-order-number'));
/**
 * Checks if value is within range.
 */

var validateRange = function validateRange(value, errorMessage) {
  if (errorMessage === void 0) {
    errorMessage = 'error.validation.invalid-range';
  }

  return validateStrictPair(function (_a) {
    var from = _a.from,
        to = _a.to;
    return from <= to;
  }, buildErrorMessage(errorMessage))(value);
};
/**
 * Checks if values are within range.
 */


var validateValuesRange = function validateValuesRange(from, to, errorMessage) {
  if (errorMessage === void 0) {
    errorMessage = 'error.validation.invalid-range';
  }

  return from <= to ? undefined : buildErrorMessage(errorMessage);
};
/**
 * Checks if value length is lower than the maximum.
 */


var validateMaxLength = function validateMaxLength(max, messageKey) {
  if (messageKey === void 0) {
    messageKey = 'error.validation.invalid-maximum-length-description';
  }

  return validate(lengthSatisfies(gte(max)), buildErrorMessage(messageKey));
};
/**
 * Checks if value length is higher than the minimum.
 */


var validateMinLength = function validateMinLength(min, messageKey) {
  if (messageKey === void 0) {
    messageKey = 'error.validation.invalid-minimum-description';
  }

  return validate(lengthSatisfies(lte(min)), buildErrorMessage(messageKey));
};
/**
 * Checks if value has the exact length.
 */


var validateExactLength = function validateExactLength(length, messageKey) {
  if (messageKey === void 0) {
    messageKey = 'error.validation.invalid-minimum-description';
  }

  return validate(lengthSatisfies(equals(length)), buildErrorMessage(messageKey));
};
/**
 * Checks if value starts with pattern.
 */


var validateStartsWith = function validateStartsWith(pattern, messageKey) {
  if (messageKey === void 0) {
    messageKey = 'error.validation.invalid-starts-with-description';
  }

  return validate(startsWith(pattern), buildErrorMessage(messageKey, {
    pattern: pattern
  }));
};
/**
 * Checks if value matches any regex.
 */


var validateMatchAnyPattern = function validateMatchAnyPattern(patterns, messageKey) {
  if (messageKey === void 0) {
    messageKey = 'error.validation.invalid-match-any-description';
  }

  return validate(matchesAny(patterns), buildErrorMessage(messageKey));
};
/**
 * Checks if value is a valid password.
 */


var validatePassword = function validatePassword(minLength) {
  return cond([[isNotPresent, always(undefined)], [lengthSatisfies(gt(minLength)), always(buildErrorMessage('error.validation.password.wrong-length', {
    minimumLength: minLength
  }))], [complement(hasNumbers), always(buildErrorMessage('error.validation.password.no-numbers'))], [complement(hasLowerCaseCharacters), always(buildErrorMessage('error.validation.password.no-lowercase-letters'))], [complement(hasUpperCaseCharacters), always(buildErrorMessage('error.validation.password.no-uppercase-letters'))], [T, always(undefined)]]);
};
/**
 * Checks if passwords are equal.
 */


var validateEqualPasswords = validatePair(function (_a) {
  var from = _a.from,
      to = _a.to;
  return from === to;
}, buildErrorMessage('error.validation.change-password-different'));
/**
 * Checks if passwords are equal.
 * @deprecated Use `validateEqualPasswords`
 */

var arePasswordsEqual = validateEqualPasswords;
/**
 * Checks if value is a valid POS code.
 */

var validatePOSCode = validate(test(/^[A-Za-z0-9.\-|_]*$/), buildErrorMessage('error.validation.invalid-pos-code'));
/**
 * Checks if value is a valid brazilian zip code.
 */

var validateBrazilianZipCode = validate(test(/^\d{8}$/), buildErrorMessage('error.validation.invalid-brazilian-zipcode'));
/**
 * Checks if value is a valid e-mail.
 */

var validateEmail = validate(test(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i), buildErrorMessage('error.validation.invalid-email'));
/**
 * Checks if value is a valid CPF.
 */

var validateCPF = validateStrict(isCPFValid, buildErrorMessage('error.validation.invalid-cpf'));
/**
 * Checks if value is a valid CNPJ.
 */

var validateCNPJ = validateStrict(isCNPJValid, buildErrorMessage('error.validation.invalid-cnpj'));
/**
 * Validates phone (https://github.com/googlei18n/libphonenumber).
 */

var validatePhone = function validatePhone(value, countryCode) {
  var errorMessage = buildErrorMessage('error.validation.invalid-phone');

  try {
    return validateStrict(function (val) {
      return parsePhoneNumber(val, countryCode).isValid();
    }, errorMessage)(value);
  } catch (error) {
    return errorMessage;
  }
};
/**
 * Validates a phone number.
 *
 * @deprecated Use `validatePhone`
 */


var validatePhoneNumber = function validatePhoneNumber(locale) {
  return function (value) {
    if (value) {
      switch (locale) {
        case COUNTRY_LOCALE.BRAZIL:
          {
            var sanitizedValue = value.replace(/\D/g, '');

            var _a = sanitizedValue.match(/^([1-9]{2})(\d{8,9})$/) || [],
                match = _a[0],
                phone = _a[2]; // A valid phone isn't a repetition of the same digit


            if (!match || /(\d)\1{7,8}$/.test(phone)) {
              return buildErrorMessage('error.validation.invalid-phone');
            }

            return undefined;
          }

        default:
          {
            return undefined;
          }
      }
    }

    return undefined;
  };
};
/**
 * Checks if contains violation.
 *
 * @deprecated Convert rules to back-end.
 */


var validateViolation = function validateViolation(fieldName, countryCode) {
  return function (value, values, props) {
    if (values === void 0) {
      values = {};
    }

    if (props === void 0) {
      props = {};
    }

    var initialFieldValue = pathOr('', ['initialValues', fieldName], props);
    var isViolation = propOr(false, 'hasViolation', values);

    if (isNil(value)) {
      return undefined;
    }

    var result = findBestMatch(value.toLowerCase(), ['pagar offline', 'telefone', 'não pagar online', 'não pagar app', 'não pagar aplicativo', 'não pagar pelo aplicativo', 'deixe telefone', 'pague dinheiro', 'whatsapp', 'maquininha cartão', 'maquina de cartão']);

    if (isViolation && value === initialFieldValue) {
      return buildErrorMessage('error.validation.violation');
    }

    var foundPhoneNumbers;

    try {
      // @ts-ignore
      foundPhoneNumbers = findNumbers(value, countryCode, {
        v2: true
      });
    } catch (error) {
      foundPhoneNumbers = [];
    }

    if (length(foundPhoneNumbers) > 0) {
      return buildErrorMessage('error.validation.violation');
    }

    if (result.bestMatch.rating >= 0.5) {
      return buildErrorMessage('error.validation.violation');
    }

    return undefined;
  };
};
/**
 * Get changed fields.
 */


var getChangedFields = function getChangedFields(values, initialValues) {
  return reduce$1(values, function (result, value, key) {
    return !isEqual(value, initialValues[key]) ? __spreadArrays(result, [key]) : result;
  }, []);
};
/**
 * Get changed fields count.
 */


var getChangedFieldsCount = function getChangedFieldsCount(values, initialValues) {
  return size(getChangedFields(values, initialValues));
};
/**
 * Get changed values.
 */


var getChangedValues = function getChangedValues(values, initialValues) {
  return fromPairs(difference(toPairs(values), toPairs(initialValues)));
};
/**
 * Removes trailing white spaces from a string.
 */


var removeTrailingWhiteSpaces = function removeTrailingWhiteSpaces(value) {
  return value ? trimEnd(value) : value;
};
/**
 * Get form values.
 */


var getFormValues = function getFormValues(form) {
  if (form && form.values) {
    return form.values;
  }

  return {};
};
/**
 * Formats a date with day, month and optional year.
 */


var formatDate = function formatDate(dateString, locale, showYear, utc) {
  if (locale === void 0) {
    locale = getDefaultLocale();
  }

  if (showYear === void 0) {
    showYear = true;
  }

  if (utc === void 0) {
    utc = false;
  }

  return buildDate(dateString, utc).toLocaleDateString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: showYear ? 'numeric' : undefined
  });
};
/**
 * Formats a date with time.
 */


var formatDateTime = function formatDateTime(dateString, locale, utc) {
  if (locale === void 0) {
    locale = getDefaultLocale();
  }

  if (utc === void 0) {
    utc = false;
  }

  return buildDate(dateString, utc).toLocaleString(locale);
};
/**
 * Formats a date with month.
 */


var formatDateWithMonth = function formatDateWithMonth(dateString, locale, isMonthShort, utc) {
  if (locale === void 0) {
    locale = getDefaultLocale();
  }

  if (isMonthShort === void 0) {
    isMonthShort = true;
  }

  if (utc === void 0) {
    utc = false;
  }

  var month = buildDate(dateString).toLocaleString(locale, {
    month: isMonthShort ? 'short' : 'long'
  });
  var options = {
    month: '2-digit',
    year: 'numeric'
  };
  return buildDate(dateString, utc).toLocaleDateString(locale, options) + " (" + month + ")";
};
/**
 * Formats a date with month, year and weekday.
 */


var formatDateWithWeekday = function formatDateWithWeekday(dateString, locale, isWeekdayShort, utc) {
  if (locale === void 0) {
    locale = getDefaultLocale();
  }

  if (isWeekdayShort === void 0) {
    isWeekdayShort = true;
  }

  if (utc === void 0) {
    utc = false;
  }

  var weekday = buildDate(dateString).toLocaleString(locale, {
    weekday: isWeekdayShort ? 'short' : 'long'
  });
  return formatDate(dateString, locale, false, utc) + " (" + weekday + ")";
};
/**
 * Formats a date with day, long month and optional year.
 */


var formatFullDate = function formatFullDate(dateString, locale, showYear, utc) {
  if (locale === void 0) {
    locale = getDefaultLocale();
  }

  if (showYear === void 0) {
    showYear = true;
  }

  if (utc === void 0) {
    utc = false;
  }

  return buildDate(dateString, utc).toLocaleDateString(locale, {
    day: '2-digit',
    month: 'long',
    year: showYear ? 'numeric' : undefined
  });
};
/**
 * Formats a date with long month and year.
 */


var formatMonthYear = function formatMonthYear(dateString, locale, utc) {
  if (locale === void 0) {
    locale = getDefaultLocale();
  }

  if (utc === void 0) {
    utc = false;
  }

  return buildDate(dateString, utc).toLocaleDateString(locale, {
    month: 'long',
    year: 'numeric'
  });
};
/**
 * Formats a time.
 */


var formatTime = function formatTime(dateString, locale, utc) {
  if (locale === void 0) {
    locale = getDefaultLocale();
  }

  if (utc === void 0) {
    utc = false;
  }

  return buildDate(dateString, utc).toLocaleTimeString(locale);
};
/**
 * Gets locale short weekdays.
 */


var getWeekdaysShort = function getWeekdaysShort(locale) {
  if (locale === void 0) {
    locale = getDefaultLocale();
  }

  return localeData(locale).weekdaysShort();
};
/**
 * Gets locale weekdays.
 */


var getWeekdays = function getWeekdays(locale) {
  if (locale === void 0) {
    locale = getDefaultLocale();
  }

  return localeData(locale).weekdays();
};
/**
 * Humanizes a date.
 */


var humanizeDate = function humanizeDate(dateString) {
  return buildMoment(dateString).fromNow();
};
/**
 * Format seconds to duration.
 */
// @ts-ignore


var convertSecondsToDuration = function convertSecondsToDuration(seconds) {
  return duration(seconds, 'seconds').format('H[h]mm[min]');
};
/**
 * Formats a number.
 */


var formatNumber = function formatNumber(value, locale) {
  return value.toLocaleString(locale);
};
/**
 * Formats an order number.
 */


var formatOrderNumber = function formatOrderNumber(value) {
  return value.slice(-4);
};
/**
 * Formats an array into string.
 */


var serializeArray = function serializeArray(array, separator, lastSeparator) {
  if (separator === void 0) {
    separator = ', ';
  }

  if (lastSeparator === void 0) {
    lastSeparator = 'and';
  }

  switch (size(array)) {
    case 0:
      return '';

    case 1:
      return "" + array[0];

    case 2:
      return array[0] + " " + lastSeparator + " " + array[1];

    default:
      return array.slice(0, -1).join(separator) + " " + lastSeparator + " " + array.slice(-1);
  }
};
/**
 * Formats a percentage (0 to 100).
 */


var formatPercentage = function formatPercentage(value, locale) {
  if (locale === void 0) {
    locale = getDefaultLocale();
  }

  var fraction = Math.floor(value) / 100;
  return fraction.toLocaleString(locale, {
    style: 'percent'
  });
};
/**
 * Formats a number to double digit.
 */


var formatNumberDoubleDigit = function formatNumberDoubleDigit(singleDigitNumber) {
  return ("0" + singleDigitNumber).slice(-2);
};
/**
 * Formats a phone number.
 */


var formatPhone = curry(function (locale, value) {
  switch (locale) {
    case COUNTRY_LOCALE.BRAZIL:
      {
        return value && value.replace(/\D/g, '').replace(/^(\d{2})(\d+)/, '($1) $2').replace(/(\d{4})(\d{1,4})$/, '$1-$2');
      }

    default:
      {
        return value;
      }
  }
});
/**
 * Formats a number to a currency as a string.
 */

var formatCurrency = function formatCurrency(value, currency, decimals, intlFormatNumber) {
  if (isNil(value)) {
    // @ts-ignore
    return value;
  }

  return intlFormatNumber(value, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: !decimals ? 0 : undefined,
    maximumFractionDigits: !decimals ? 0 : undefined
  });
}; // eslint-disable-next-line


var logError = console.error;
var moneyShape = PropTypes.shape({
  currency: PropTypes.string,
  value: PropTypes.number
});
/**
 * Builds a money.
 */

var buildMoney = function buildMoney(value, currency) {
  return {
    value: value,
    currency: currency
  };
};
/**
 * Parses a money.
 */


var parseMoney = function parseMoney(value, locale) {
  if (locale === void 0) {
    locale = getDefaultLocale();
  }

  var currencyInfo = findCurrency(getCurrency(locale));
  var decimalFactor = 10;

  if (!value || !currencyInfo) {
    return undefined;
  }

  return buildMoney(Number(value.replace(/\D/g, '')) / Math.pow(decimalFactor, currencyInfo.decimalDigits), currencyInfo.code);
};
/**
 * Creates a money from value.
 */


var toMoney = function toMoney(value, locale) {
  if (locale === void 0) {
    locale = getDefaultLocale();
  }

  var currencyInfo = findCurrency(getCurrency(locale));

  if (!value || !currencyInfo) {
    return undefined;
  }

  return buildMoney(value, currencyInfo.code);
};

var notificationToTarget = function notificationToTarget(notification) {
  return ".tour-box--event-" + notification;
};

var notificationTargetToElement = function notificationTargetToElement(target) {
  return target.replace(/^\./, '');
};

var notificationClassForEvent = pipe(notificationToTarget, notificationTargetToElement);

var detectNotificationDeviceTarget = function detectNotificationDeviceTarget(_a) {
  var desktop = _a.desktop,
      mobile = _a.mobile;
  return notificationToTarget(detectDeviceTarget({
    desktop: desktop,
    mobile: mobile
  }));
};
/**
 * Define document title.
 */


var setPageTitle = function setPageTitle(routeTitle, detail) {
  var message = routeTitle;
  window.document.title = "" + getDefaultPageTitle() + (message ? " - " + message : '') + (detail ? " - " + detail : '');
};

var Parser = require('json2csv').Parser;

var formatObjList2Csv = function formatObjList2Csv(objList, fields) {
  var json2csvParser = new Parser({
    fields: fields
  });
  return json2csvParser.parse(objList);
};
/**
 * Percentage difference between two numbers.
 */


var percentageDifference = function percentageDifference(a, b, round) {
  if (round === void 0) {
    round = false;
  }

  var diff = (b - a) / a * 100;
  return round ? Math.round(diff) : diff;
};
/**
 * Calculates progress percentage.
 */


var calculateProgressPercentage = function calculateProgressPercentage(goal) {
  return function (current) {
    return clamp(0, 100, current * 100 / goal);
  };
};

var PROGRESS_STATUS;

(function (PROGRESS_STATUS) {
  PROGRESS_STATUS["DANGER"] = "DANGER";
  PROGRESS_STATUS["WARNING"] = "WARNING";
  PROGRESS_STATUS["SUCCESS"] = "SUCCESS";
  PROGRESS_STATUS["PERFECT"] = "PERFECT";
})(PROGRESS_STATUS || (PROGRESS_STATUS = {}));
/**
 * Get progress status.
 */


var getProgressStatus = function getProgressStatus(value, dangerThreshold, warningThreshold) {
  if (value < dangerThreshold) {
    return PROGRESS_STATUS.DANGER;
  }

  if (value < warningThreshold) {
    return PROGRESS_STATUS.WARNING;
  }

  if (value < 100) {
    return PROGRESS_STATUS.SUCCESS;
  }

  return PROGRESS_STATUS.PERFECT;
};

var addPropInObject = function addPropInObject(obj, props) {
  keys(props).reduce(function (acc, prop) {
    acc[prop] = props[prop];
    return acc;
  }, obj);
  return obj;
};

var createErrorWith = function createErrorWith(props) {
  if (props === void 0) {
    props = {};
  }

  var error = new Error();
  return addPropInObject(error, props);
};

var makeCancelablePromise = function makeCancelablePromise(promise) {
  var isCanceled = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return isCanceled ? reject(createErrorWith(_assign({
        isCanceled: isCanceled
      }, val))) : resolve(val);
    }, function (error) {
      return reject(isCanceled ? createErrorWith({
        isCanceled: isCanceled
      }) : addPropInObject(error, {
        isCanceled: isCanceled
      }));
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      isCanceled = true;
    }
  };
};
/**
 * Generates a random float between given range.
 */


var randomFloat = function randomFloat(min, max) {
  if (min === void 0) {
    min = 0;
  }

  if (max === void 0) {
    max = Number.MAX_SAFE_INTEGER;
  }

  return Math.random() * (max - min) + min;
};
/**
 * Generates a random integer between given range.
 */


var randomInt = function randomInt(min, max) {
  if (min === void 0) {
    min = 0;
  }

  if (max === void 0) {
    max = Number.MAX_SAFE_INTEGER;
  }

  return Math.floor(min + Math.random() * (max + 1 - min));
};
/**
 * Builds request initial state overriding given attributes.
 */


var requestInitialState = function requestInitialState(attrs) {
  if (attrs === void 0) {
    attrs = {};
  }

  return mergeDeepRight({
    data: {},
    isLoading: false,
    loaded: false,
    error: ''
  }, attrs);
};
/**
 * Builds request loading state.
 */


var requestLoadingState = function requestLoadingState(state) {
  return _assign(_assign({}, state), {
    isLoading: true,
    loaded: false
  });
};
/**
 * Builds request success state.
 */


var requestSuccessState = function requestSuccessState(state) {
  return _assign(_assign({}, state), {
    isLoading: false,
    loaded: true
  });
};
/**
 * Builds request error state.
 */


var requestErrorState = function requestErrorState(state, action) {
  return _assign(_assign({}, state), {
    isLoading: false,
    loaded: false,
    error: action.error || true
  });
};
/**
 * Combines a list of reducers by running then in sequence.
 */


var reduceReducers = function reduceReducers() {
  var reducers = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    reducers[_i] = arguments[_i];
  }

  return function (state, action) {
    return reducers.reduce(function (prevState, reducer) {
      return reducer(prevState, action);
    }, state);
  };
};
/**
 * It's a mapStateToProps abstraction that delegates the access to state to the selectors.
 *
 * @param {Function<Object<Function>>} mapStateToProps - The mapStateToProps redux under @connect
 * @return {Function<Object<Function<Object>>>} All transformed props mapped to its statified version
 */


var statify = function statify(mapStateToProps) {
  return isNil(mapStateToProps) ? mapStateToProps : function (state, ownProps) {
    return map$1(function (selector) {
      return selector(state, ownProps);
    }, isFunction(mapStateToProps) ? mapStateToProps(ownProps) : mapStateToProps);
  };
};
/**
 * It's a mapDispatchToProps abstraction that already handles the dispatch calls.
 *
 * @param {Function<Object<Function>>} mapDispatchToProps - The mapDispatchToProps redux under @connect
 * @return {Function<Object<Function<Function>>>} All transformed props mapped to its dispatched version
 */


var dispatchify = function dispatchify(mapDispatchToProps) {
  return isFunction(mapDispatchToProps) ? function (dispatch, ownProps) {
    return bindActionCreators(mapDispatchToProps(ownProps), dispatch);
  } : mapDispatchToProps;
};
/**
 * Push relative link.
 */


var pushRelativeLink = function pushRelativeLink(router, location, link) {
  router.push(location.pathname.replace(/\/$/, '') + "/" + link);
};
/**
 * Replace url path parameters.
 */


var replaceURLPathParameters = function replaceURLPathParameters(url) {
  var values = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    values[_i - 1] = arguments[_i];
  }

  return (url.match(/:[a-zA-Z0-9_]+/g) || []).reduce(function (acc, pathParameter, index) {
    return acc.replace(pathParameter, values[index]);
  }, url);
};
/**
 * Builds a path.
 */


var buildPath = function buildPath() {
  var paths = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    paths[_i] = arguments[_i];
  }

  return paths.join('/');
};
/**
 * Gets URL query parameters.
 */


var getQueryParams = function getQueryParams() {
  return parse(window.location.search, {
    ignoreQueryPrefix: true
  });
};
/**
 * Builds URL query parameters.
 */


var buildQueryParams = function buildQueryParams(params) {
  return stringify(params, {
    addQueryPrefix: true
  });
};
/**
 * Removes query parameter from query string.
 */


var removeQueryParam = function removeQueryParam(param) {
  return buildQueryParams(omit([param], getQueryParams()));
};
/**
 * Gets URL without a query parameter.
 */


var getURLWithoutQueryParam = function getURLWithoutQueryParam(param) {
  return "" + window.location.pathname + removeQueryParam(param);
};
/**
 * Converts a path to an absolute one.
 */


var absolutePath = function absolutePath(path) {
  return path.startsWith('/') ? path : "/" + path;
};
/**
 * Converts a path to a relative one.
 */


var relativePath = function relativePath(path) {
  return path.startsWith('/') ? path.replace('/', '') : path;
};
/**
 * Populates the segments of a route pattern.
 */


var routePattern = function routePattern(path, replacements) {
  if (replacements === void 0) {
    replacements = {};
  }

  return toPairs(replacements).reduce(function (finalPath, _a) {
    var segment = _a[0],
        value = _a[1];
    return finalPath.replace(":" + segment, value);
  }, path);
};
/**
 * Checks if the given path is a sub route (a tab, for example).
 */


var isSubRoute = function isSubRoute(path) {
  return path ? path.substring(1).includes('/') : false;
};
/**
 * Returns a route path given a set of routes.
 */


var routePath = compose(last$1, filter(Boolean), map$1(prop('path')));
/**
 * Generate a route compatible with any subpath.
 *
 * @param {String} route - Route
 * @return {String} Route with any subpath support
 */

var withSubPaths = function withSubPaths(route) {
  return route + "(/**)";
};

var sanitizeSpreadsheetName = function sanitizeSpreadsheetName(name) {
  return name.replace(/:|\\|\/|\?|\*|\[|\]|\|/g, '_').substring(0, 31);
};

var sheetBuilder = function sheetBuilder(sheet) {
  if (sheet === void 0) {
    sheet = {
      name: 'Sheet',
      data: []
    };
  }

  return {
    addRow: function addRow(row) {
      return sheetBuilder(_assign(_assign({}, sheet), {
        data: __spreadArrays(sheet.data, [row])
      }));
    },
    name: sheet.name,
    data: sheet.data
  };
};
/**
 * Fluent interface to build spreadsheet reports.
 *
 * @example Building a spreadsheet with two worksheets
 * const spreadsheet =
 *   createSpreadsheet()
 *     .buildSheet("Products", sheet =>
 *       sheet
 *         .addRow(["Product", "Price"])
 *         .addRow(["Coffee", 2.5])
 *         .addRow(["Bread", 0.2])
 *         .addRow(["Butter", "5.4"])
 *      )
 *      .buildSheet("Employees", sheet =>
 *        sheet
 *          .addRow(["Name", "Age"])
 *          .addRow(["Sasha", 30])
 *          .addRow(["Tori", 28])
 *      );
 */


var createSpreadsheet = function createSpreadsheet(spreadsheet) {
  if (spreadsheet === void 0) {
    spreadsheet = {
      sheets: []
    };
  }

  return {
    buildSheet: function buildSheet(name, builder) {
      return createSpreadsheet(_assign(_assign({}, spreadsheet), {
        sheets: __spreadArrays(spreadsheet.sheets, [builder(sheetBuilder({
          name: sanitizeSpreadsheetName(name),
          data: []
        }))])
      }));
    },
    sheets: spreadsheet.sheets
  };
};
/**
 * Get weekday shifts.
 */


var getWeekdayShifts = prop('shifts');
/**
 * Get weekday shifts length.
 */

var getWeekdaysShiftsLength = pipe(getWeekdayShifts, length);
/**
 * Get today's weekday.
 */

var getTodayWeekday = pipe(defaultTo([]), filter(propEq('weekday', now().weekday() + 1)));
/**
 * Set weekday shifts.
 */

var setWeekdayShifts = function setWeekdayShifts(_a, shifts) {
  var weekday = _a.weekday;
  return {
    weekday: weekday,
    shifts: shifts
  };
};
/**
 * Set weekdays shifts.
 */


var setWeekdaysShifts = function setWeekdaysShifts(weekdays, shifts) {
  return weekdays.map(function (day) {
    return setWeekdayShifts(day, shifts);
  });
};
/**
 * Add shift to a given weekday.
 */


var addShiftToWeekday = function addShiftToWeekday(shift, weekday, weekdays) {
  return over(lensPath([weekday - 1, 'shifts']), function (shifts) {
    return shift.openingTime && shift.closingTime ? sortShifts(__spreadArrays(shifts, [shift])) : shifts;
  })(weekdays);
};
/**
 * Add shift to a given weekdays.
 */


var addShiftToWeekdays = function addShiftToWeekdays(weekdays, weekdaysToChange, shift) {
  return isEmpty(weekdays) || isEmpty(weekdaysToChange) ? weekdays : weekdaysToChange.reduce(function (changedWeekdays, weekday) {
    return addShiftToWeekday(shift, weekday, changedWeekdays);
  }, weekdays);
};
/**
 * Finds shift index by weekday and times.
 */


var findShiftIndexByWeekdayAndTimes = function findShiftIndexByWeekdayAndTimes(_a) {
  var weekday = _a.weekday,
      weekdays = _a.weekdays,
      openingTime = _a.openingTime,
      closingTime = _a.closingTime;
  var index = pipe(find$1(propEq('weekday', weekday)), propOr([], 'shifts'), findIndex(pipe(buildMomentShift(openingTime, closingTime), areMomentShiftTimesEqual)))(weekdays);

  if (index === -1) {
    throw new Error('[Opening hours] could not find index of shift on given weekdays');
  }

  return index;
};
/**
 * Flatten weekday shifts.
 */


var flattenedWeekdaysShifts = pipe(map$1(prop('shifts')), flatten);
var esCO = {
  "error.form": "Hubo un error al guardar los datos. Por favor, intenta de nuevo más tarde.",
  "error.validation.cannot-be-equal": "El horario final del periodo no puede ser igual al horario de inicio.",
  "error.validation.invalid-brazilian-zipcode": "CEP inválido",
  "error.validation.invalid-cnpj": "CNPJ inválido",
  "error.validation.invalid-cpf": "CPF inválido",
  "error.validation.invalid-date": "Fecha inválida.",
  "error.validation.invalid-date-range": "El horario final del periodo no puede ser menor al horario de inicio.",
  "error.validation.invalid-email": "Correo inválido.",
  "error.validation.invalid-match-any-description": "El valor no está permitido",
  "error.validation.invalid-maximum-length-description": "Límite de conteo de caracteres excedido",
  "error.validation.invalid-minimum-description": "Por favor, danos más detalles",
  "error.validation.invalid-order-number": "El número del pedido debe tener cuatro números.",
  "error.validation.invalid-phone": "Este número no parece un teléfono válido.",
  "error.validation.invalid-pos-code": "El código PDV debe contener sólo letras, números, puntos (.), guiones (-), pipes (|) y guiones bajos(_)",
  "error.validation.invalid-range": "El valor máximo debe ser mayor o igual al mínimo.",
  "error.validation.invalid-starts-with-description": "El valor debe comenzar con {pattern}",
  "error.validation.number-exceeds-max": "El valor debe ser menor o igual a {max}.",
  "error.validation.number-exceeds-min": "El valor debe ser mayor o igual a {min}.",
  "error.validation.number-exceeds-min-integer": "El valor debe ser mayor que {min}.",
  "error.validation.numbers-only": "El valor debe ser un número.",
  "error.validation.password.no-lowercase-letters": "Tu contraseña debe contener al menos una letra minúscula.",
  "error.validation.password.no-numbers": "Tu contraseña debe contener al menos un número.",
  "error.validation.password.no-uppercase-letters": "Tu contraseña debe contener al menos una letra mayúscula.",
  "error.validation.password.wrong-length": "Tu contraseña debe contener como mínimo {minimumLength} caracteres.",
  "error.validation.positive-only": "El valor debe ser positivo.",
  "error.validation.range-exceeds-period": "Periodo superior a {interval} {type}.",
  "error.validation.required-fields": "Completa este campo para continuar.",
  "error.validation.required-logo": "La imagen de logo es obligatoria",
  "error.validation.violation": "El texto escrito está en desacuerdo con las políticas de iFood."
};
var esMX = {
  "error.form": "Hubo un error al guardar los datos. Por favor, intenta de nuevo más tarde.",
  "error.validation.cannot-be-equal": "El horario final del periodo no puede ser igual al horario de inicio.",
  "error.validation.invalid-brazilian-zipcode": "CEP inválido",
  "error.validation.invalid-cnpj": "CNPJ inválido",
  "error.validation.invalid-cpf": "CPF inválido",
  "error.validation.invalid-date": "Fecha inválida.",
  "error.validation.invalid-date-range": "El horario final del periodo no puede ser menor al horario de inicio.",
  "error.validation.invalid-email": "Correo inválido.",
  "error.validation.invalid-match-any-description": "El valor no está permitido",
  "error.validation.invalid-maximum-length-description": "Límite de conteo de caracteres excedido",
  "error.validation.invalid-minimum-description": "Por favor, danos más detalles",
  "error.validation.invalid-order-number": "El número del pedido debe tener cuatro números.",
  "error.validation.invalid-phone": "Este número no parece un teléfono válido.",
  "error.validation.invalid-pos-code": "El código PDV debe contener sólo letras, números, puntos (.), guiones (-), pipes (|) y guiones bajos(_)",
  "error.validation.invalid-range": "El valor máximo debe ser mayor o igual al mínimo.",
  "error.validation.invalid-starts-with-description": "El valor debe comenzar con {pattern}",
  "error.validation.number-exceeds-max": "El valor debe ser menor o igual a {max}.",
  "error.validation.number-exceeds-min": "El valor debe ser mayor o igual a {min}.",
  "error.validation.number-exceeds-min-integer": "El valor debe ser mayor que {min}.",
  "error.validation.numbers-only": "El valor debe ser un número.",
  "error.validation.password.no-lowercase-letters": "Su contraseña debe contener al menos una letra minúscula.",
  "error.validation.password.no-numbers": "Su contraseña debe contener al menos un número.",
  "error.validation.password.no-uppercase-letters": "Su contraseña debe contener al menos una letra mayúscula.",
  "error.validation.password.wrong-length": "Su contraseña debe contener como mínimo {minimumLength} caracteres.",
  "error.validation.positive-only": "El valor debe ser positivo.",
  "error.validation.range-exceeds-period": "Periodo superior a {interval} {type}.",
  "error.validation.required-fields": "Llena los campos destacados para continuar.",
  "error.validation.required-logo": "La imagen de logo es obligatoria",
  "error.validation.violation": "El texto escrito está en desacuerdo con las políticas de SinDelantal."
};
var ptBR = {
  "error.form": "Ocorreu um erro ao salvar os dados. Por favor, tente novamente mais tarde.",
  "error.validation.cannot-be-equal": "O horário final do período não pode ser igual ao horário de início.",
  "error.validation.invalid-brazilian-zipcode": "CEP inválido",
  "error.validation.invalid-cnpj": "CNPJ inválido",
  "error.validation.invalid-cpf": "CPF inválido",
  "error.validation.invalid-date": "Data inválida.",
  "error.validation.invalid-date-range": "O horário final do período não pode ser menor do que o horário de início.",
  "error.validation.invalid-email": "Email inválido.",
  "error.validation.invalid-match-any-description": "O valor não é permitido",
  "error.validation.invalid-maximum-length-description": "Limite de caracteres excedido",
  "error.validation.invalid-minimum-description": "Por favor, conte-nos mais detalhes",
  "error.validation.invalid-order-number": "O número do pedido deve ter quatro números.",
  "error.validation.invalid-phone": "Este número não parece um telefone válido.",
  "error.validation.invalid-pos-code": "O código PDV deve conter apenas letras, números, pontos (.), traços (-) e pipes (|).",
  "error.validation.invalid-range": "O valor máximo deve ser maior ou igual ao mínimo.",
  "error.validation.invalid-starts-with-description": "O valor deve começar com {pattern}",
  "error.validation.number-exceeds-max": "O valor deve ser menor ou igual a {max}.",
  "error.validation.number-exceeds-min": "O valor deve ser maior ou igual a {min}.",
  "error.validation.number-exceeds-min-integer": "O valor deve ser maior que {min}.",
  "error.validation.numbers-only": "O valor deve ser um número.",
  "error.validation.password.no-lowercase-letters": "Sua senha deve conter ao menos uma letra minúscula.",
  "error.validation.password.no-numbers": "Sua senha deve conter ao menos um número.",
  "error.validation.password.no-uppercase-letters": "Sua senha deve conter ao menos uma letra maiúscula.",
  "error.validation.password.wrong-length": "Sua senha deve conter no mínimo {minimumLength} caracteres.",
  "error.validation.positive-only": "O valor deve ser positivo.",
  "error.validation.range-exceeds-period": "Período superior a {interval} {type}.",
  "error.validation.required-fields": "Preencha os campos destacados para prosseguir.",
  "error.validation.required-logo": "A imagem de logo é obrigatória",
  "error.validation.violation": "O texto digitado está em desacordo com as políticas do iFood."
};

var _a;

var index = (_a = {}, _a[COUNTRY_LOCALE.BRAZIL] = ptBR, _a[COUNTRY_LOCALE.MEXICO] = esMX, _a[COUNTRY_LOCALE.COLOMBIA] = esCO, _a);
export { COMPANIES, COMPANY_CONFIGS, COUNTRIES, COUNTRY_CONFIGS, COUNTRY_LOCALE, FILE_SIZE_PREFIXES, LOCAL_STORAGE_TEST_KEY, MOBILE_BREAKPOINT, PROGRESS_STATUS, TIME_UNIT, UNEXPECTED_ERROR, absolutePath, addShiftToWeekday, addShiftToWeekdays, allValuesSatisfies, anyValuesSatisfies, areMomentShiftTimesEqual, arePasswordsEqual, areShiftsAdjacent, areShiftsEqual, areShiftsIntersected, argbToRgba, automaticDownloadFile, b64toBlob, buildDate, buildErrorMessage, buildISODate, buildISOYearMonth, buildImage, buildMoment, buildMomentShift, buildMomentWithPattern, buildMoney, buildPath, buildPickers, buildQueryParams, buildTime, buildTimeShift, calculateProgressPercentage, compareTwoStrings, convertSecondsToDuration, createSpreadsheet, dateToISOWeekday, dayEndTime, dayShift, dayStartTime, delay, detectDeviceTarget, detectNotificationDeviceTarget, dispatchify, downloadFile, durationToUTCMoment, eqIgnoringCase, errorEquals, errorHandler, findBestMatch, findFirst, findShiftIndexByWeekdayAndTimes, flattenedWeekdaysShifts, formatCurrency, formatDate, formatDateTime, formatDateWithMonth, formatDateWithWeekday, formatFullDate, formatMinutesDuration, formatMinutesDurationToISOTime, formatMonthYear, formatNumber, formatNumberDoubleDigit, formatObjList2Csv, formatOrderNumber, formatPercentage, formatPhone, formatSecondsDuration, formatTime, formatTimeToText, fromKebabToConstantCase, futureDay, generate, generateTimeOptions, generateTimeOptionsAsMultiShift, getCardImageURL, getChangedFields, getChangedFieldsCount, getChangedValues, getCountryConfig, getDaysInRange, getDefaultLocale, getDefaultPageTitle, getDomain, getDomainCompany, getDomainCountry, getFormValues, getHighlightImageURL, getImageFileName, getImageURL, getLocalePhoneMaxLength, getOverloadedFileSize, getProgressStatus, getQueryParams, getServiceURL, getServiceURLByEnv, getTodayWeekday, getURLWithoutQueryParam, getWeekdayShifts, getWeekdays, getWeekdaysShiftsLength, getWeekdaysShort, handleSubmitFail, hasLocalStorage, hasLowerCaseCharacters, hasNoChildrenProp, hasNumbers, hasOnlyNumbers, hasUpperCaseCharacters, humanizeDate, imageShape, includesIgnoringCase, intersectShifts, isAndroid, isBetween, isBetweenStartOfPastYear, isCNPJValid, isCPFValid, isCustomMomentRangeInstantaneous, isCustomMomentRangeValid, isCustomMomentRangeValidWithinPeriod, isDayEndTime, isDayStartTime, isErrorMessage, isFirst, isImage, isInMobileViewport, isIos, isLast, isNegative, isNotPresent, isPeriodBetweenOneYear, isPickers, isPickersRange, isPositive, isPresent, isSameDate, isSelectableDate, isSelectableDateRange, isSelectableFutureDate, isSelectablePastDate, isSelectablePastOrCurrentDate, isSelectableTodayAndYesterdayDate, isShift, isShiftComplete, isShiftOvernight, isString, isStringNotEmpty, isStringPresent, isSubRoute, isTime, isToday, isoMonth, isoWeekday, lastDayOfMonth, lengthSatisfies, index as localesMessages, logError, makeCancelablePromise, matchesAny, maxShiftClosingTime, maxTime, mergeAdjacentShifts, mergeShifts, minShiftOpeningTime, minTime, minutesToDuration, momentRangeToShift, momentToDatePeriod, momentToLimit, momentToTime, momentToTimePeriod, moneyShape, monthFromISO, next, normalize, normalizePeriod, notificationClassForEvent, notificationTargetToElement, notificationToTarget, now, openLinkInNewTab, padRight, parseMoney, pastDay, percentageDifference, pickersRangeToCustomMomentRange, pickersToDateTimePeriod, pickersToMoment, prettierFileSize, prev, preventDefault, pushRelativeLink, randomFloat, randomInt, reduceReducers, registerEvent, relativePath, removeAccents, removeAccentsAndUpperCase, removeQueryParam, removeTrailingWhiteSpaces, renameObjectKeys, replaceURLPathParameters, requestErrorState, requestInitialState, requestLoadingState, requestSuccessState, roundToNearestMultiple, routePath, routePattern, saveFileURL, secondsToDuration, serializeArray, setPageTitle, setWeekdayShifts, setWeekdaysShifts, shallowDifference, shiftDuration, shiftToMomentRange, shiftToTimeRange, sortItemsByIndexes, sortItemsByKeys, sortShifts, sortTwoShifts, splitShiftsPastMidnight, startsWithAny, statify, sumBy, timeDiff, timeEq, timePeriodToLimit, timePeriodToMoment, timePeriodToNowMoment, timePeriodToTime, timePeriodsToMomentShift, timePeriodsToTimeShift, timeRangeToShift, timeToHours, timeToMinutes, timeToSeconds, toDate, toISODate, toISOYearMonth, toLocalizedFormat, toMoment, toMomentWithPattern, toMoney, today, toggleArrayItem, toggleArrayItemWith, toggleObjectItem, truncate, unregisterEvent, validate, validateBrazilianZipCode, validateCNPJ, validateCPF, validateDate, validateEmail, validateEqualPasswords, validateExactLength, validateMatchAnyPattern, validateMax, validateMaxCurrency, validateMaxLength, validateMin, validateMinInteger, validateMinLength, validateMomentRange, validateMomentRangeNotInstantaneous, validateMomentRangeWithinPeriod, validateNotEmpty, validateNumber, validateOnlyNumbers, validateOrderNumber, validatePOSCode, validatePair, validatePassword, validatePhone, validatePhoneMaxLength, validatePhoneNumber, validatePickersRange, validatePositive, validateRange, validateRequired, validateRequiredDateRange, validateRequiredImage, validateRequiredLogoImage, validateShiftRange, validateStartsWith, validateStrict, validateStrictPair, validateValuesRange, validateViolation, weekdayFromISO, withSubPaths };